/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_DisclaimerInputs */

const en_map_disclaimer = /** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approximate location shown. Exact address shared after purchase.`)
};

const id_map_disclaimer = /** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi perkiraan ditampilkan. Alamat pasti dibagikan setelah pembelian.`)
};

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const es_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const fr_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const de_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const ja_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const zh_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const ar_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const it_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const ru_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const pt_map_disclaimer = en_map_disclaimer;

/** @type {(inputs: Map_DisclaimerInputs) => LocalizedString} */
const ko_map_disclaimer = en_map_disclaimer;

/**
* | output |
* | --- |
* | "Approximate location shown. Exact address shared after purchase." |
*
* @param {Map_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const map_disclaimer = /** @type {((inputs?: Map_DisclaimerInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_DisclaimerInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_disclaimer(inputs)
	if (locale === "es") return es_map_disclaimer(inputs)
	if (locale === "fr") return fr_map_disclaimer(inputs)
	if (locale === "de") return de_map_disclaimer(inputs)
	if (locale === "ja") return ja_map_disclaimer(inputs)
	if (locale === "zh") return zh_map_disclaimer(inputs)
	if (locale === "ar") return ar_map_disclaimer(inputs)
	if (locale === "id") return id_map_disclaimer(inputs)
	if (locale === "it") return it_map_disclaimer(inputs)
	if (locale === "ru") return ru_map_disclaimer(inputs)
	if (locale === "pt") return pt_map_disclaimer(inputs)
	return ko_map_disclaimer(inputs)
});